import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withRouter } from 'react-router-dom'
import { withAuthorization } from '../Session'
import { compose } from 'recompose'
import { withFirebase } from '../Firebase/context'
import { Typography } from '@material-ui/core'
import './style.css'


function AccordionComponentBase(props) {

    // ----- Material UI styling----------------------------//
    const useStyles = makeStyles((theme) => ({
        root: {
          width: '100%',
        },
        heading: {
          fontSize: theme.typography.pxToRem(15),
          fontWeight: theme.typography.fontWeightRegular,
        },
         secondaryHeading: {
            fontSize: theme.typography.pxToRem(15),
            color: theme.palette.text.secondary,
  },
      }));
      const classes = useStyles();
    // -------------------------------------------------------// 
  

    //   const [ loading, setLoading ] = useState(false)

      const [state, setState] = useState({
        signUpLogin: true,
        onboardingVideo: false,
        // learnChallenges: false,
        masterSlackSpace: false,
        registerSchedule: false,
        sponsorInfo: false,
        completeProfile: false,
        introYourself: false,
        regionSpeedTeam: false,
        introOnSlack: false,
        useCredits: false,
        chooseChallenge: false,
        findMentor: false,
        projectPlanner: false,
        selectDatasets: false,
        startToStoryBoard: false,
        videoSW: false,
        teamRepresent: false,
        completeSurvey: false
      })

    useEffect(() => {
        // setLoading(true)
        let uid = props.firebase.auth.currentUser.uid;
        props.firebase.progressList(uid).on("value", snapshot => {
            let _snapshotVal = snapshot.val();
            if(_snapshotVal){
                let _newState = {...state};
                if(_snapshotVal.gettingStarted){
                    // _newState['signUpLogin'] = _snapshotVal.gettingStarted.signUpLogin?_snapshotVal.gettingStarted.signUpLogin:true;
                    _newState['onboardingVideo'] = _snapshotVal.gettingStarted.onboardingVideo?_snapshotVal.gettingStarted.onboardingVideo:false;
                    // _newState['learnChallenges'] = _snapshotVal.gettingStarted.learnChallenges?_snapshotVal.gettingStarted.learnChallenges:false;
                    _newState['masterSlackSpace'] = _snapshotVal.gettingStarted.masterSlackSpace?_snapshotVal.gettingStarted.masterSlackSpace:false;
                    _newState['registerSchedule'] = _snapshotVal.gettingStarted.registerSchedule?_snapshotVal.gettingStarted.registerSchedule:false;
                    _newState['sponsorInfo'] = _snapshotVal.gettingStarted.sponsorInfo?_snapshotVal.gettingStarted.sponsorInfo:false;
                }
                if(_snapshotVal.formYourTeam){
                    _newState['completeProfile'] = _snapshotVal.formYourTeam.completeProfile?_snapshotVal.formYourTeam.completeProfile:false;
                    _newState['introYourself'] = _snapshotVal.formYourTeam.introYourself?_snapshotVal.formYourTeam.introYourself:false;
                    _newState['regionSpeedTeam'] = _snapshotVal.formYourTeam.regionSpeedTeam?_snapshotVal.formYourTeam.regionSpeedTeam:false;
                    _newState['introOnSlack'] = _snapshotVal.formYourTeam.introOnSlack?_snapshotVal.formYourTeam.introOnSlack:false;
                }                                                               
                if(_snapshotVal.startHacking){                                  
                    _newState['useCredits'] = _snapshotVal.startHacking.useCredits?_snapshotVal.startHacking.useCredits:false;
                    _newState['chooseChallenge'] = _snapshotVal.startHacking.chooseChallenge?_snapshotVal.startHacking.chooseChallenge:false;
                    _newState['findMentor'] = _snapshotVal.startHacking.findMentor?_snapshotVal.startHacking.findMentor:false;
                    _newState['projectPlanner'] = _snapshotVal.startHacking.projectPlanner?_snapshotVal.startHacking.projectPlanner:false;
                    _newState['selectDatasets'] = _snapshotVal.startHacking.selectDatasets?_snapshotVal.startHacking.selectDatasets:false;
                }
                if(_snapshotVal.presentSubmit){
                    _newState['startToStoryBoard'] = _snapshotVal.presentSubmit.startToStoryBoard?_snapshotVal.presentSubmit.startToStoryBoard:false;
                    _newState['videoSW'] = _snapshotVal.presentSubmit.videoSW?_snapshotVal.presentSubmit.videoSW:false;
                    _newState['teamRepresent'] = _snapshotVal.presentSubmit.teamRepresent?_snapshotVal.presentSubmit.teamRepresent:false;
                    _newState['completeSurvey'] = _snapshotVal.presentSubmit.completeSurvey?_snapshotVal.presentSubmit.completeSurvey:false;
                }
                setState(_newState);
            }
            // setLoading(false)
        })
    }, [])

    useEffect(()=>{
        props.updateMainProgress(totalSections, sectionsComplete);
    });
      
              
    const totalSections = 4;
    const sectionsComplete = ()=>{
        let _secCompleteCount = 0;
        //gettingStarted
        if(gettingStartedCount() === 5) _secCompleteCount++;
        if(formYourTeamCount() === 4) _secCompleteCount++;
        if(startHackingCount() === 5) _secCompleteCount++;
        if(presentSubmitCount() === 4) _secCompleteCount++;

        //console.log("sections complete", _secCompleteCount);
        return _secCompleteCount;
    }

    const gettingStartedCount = ()=>{        
        let _completedGettingStarted = 0;
        ['signUpLogin','onboardingVideo', 'masterSlackSpace', 'registerSchedule', 'sponsorInfo'].map(key => {
            if(state[key]){_completedGettingStarted++;}
            return null;
        });
        return _completedGettingStarted;
    }

    const formYourTeamCount = () => {
        let _completedFormTeam = 0;
        ['completeProfile', 'introYourself','regionSpeedTeam','introOnSlack',].map(key => {
            if(state[key]){_completedFormTeam++;}
        });
        return _completedFormTeam
    }

    const startHackingCount = () => {
        let _completedStartHacking = 0;
        ['useCredits','chooseChallenge','findMentor','projectPlanner','selectDatasets',].map(key => {
            if(state[key]){_completedStartHacking++;}
        });
        return _completedStartHacking
    }


    const presentSubmitCount = () => {
        let _completedSubmitScore = 0;
        ['startToStoryBoard','videoSW','teamRepresent','completeSurvey',].map(key => {
            if(state[key]){_completedSubmitScore++;}
        });
        return _completedSubmitScore
    }


    // Handle Getting Started Firebase Function
    const handleGettingStarted = (e, value) => {
        let uid = props.firebase.auth.currentUser.uid;
        let objName = e.target.name;
        setState({
          ...state,
          [e.target.name]: e.target.checked
        });
        let objToSave = {};
        objToSave[objName] =  e.target.checked;
        //console.log("Name", e.target.name);
        //console.log("OBJECT SAVED", objToSave);
        props.firebase.gettingStarted(uid).update(objToSave);

        /*
        props.firebase.gettingStarted(uid).on("value", (snapshot) => {
            let _completedGettingStarted = 0;
            snapshot.forEach((childSnapshot) => {
                // console.log(childSnapshot.val())
                if(childSnapshot.val() == true){
                    _completedGettingStarted++;
                }
            })
            setCompletedGettingStarted(_completedGettingStarted);
        })
        */
       //props.updateMainProgress(totalSections, sectionsComplete);
    }


        // Handle Form Your Team Accorrdion Firebase Function
        const handleFormYourTeam = (e, value) => {
            let uid = props.firebase.auth.currentUser.uid;
            let objName = e.target.name;
            setState({
              ...state,
              [e.target.name]: e.target.checked
            });
            let objToSave = {};
            objToSave[objName] =  e.target.checked;
            props.firebase.formYourTeam(uid).update(objToSave);
        }
    

      // Handle Start Hacking Firebase Function
      const handleStartHacking = (e, value) => {
        let uid = props.firebase.auth.currentUser.uid;
        let objName = e.target.name;
        setState({
          ...state,
          [e.target.name]: e.target.checked
        });
        let objToSave = {};
        objToSave[objName] =  e.target.checked;
        props.firebase.startHacking(uid).update(objToSave);
    }


    // Handle Present Submit..... Accordion Firebase Function
    const handlePresentSubmit = (e, value) => {
        let uid = props.firebase.auth.currentUser.uid;
        let objName = e.target.name;
        setState({
          ...state,
          [e.target.name]: e.target.checked
        });
        let objToSave = {};
        objToSave[objName] =  e.target.checked;
        props.firebase.presentSubmit(uid).update(objToSave);
    }

    
    // --------Expansion of the Accordion on the based of count value ------------

    // const [ expanded, setExpanded ] = useState(false)

    
    // const handleExpansion = (panel) => (e, newExpanded) => {
    //     setExpanded(newExpanded ? panel : false)
    // }

    // if(gettingStartedCount() !== 5){
    //     handleExpansion('panel1')
    // }
    // else if(formYourTeamCount() !==4){
    //     handleExpansion('panel2')
    // }
    // else if(startHackingCount() !==5){
    //     handleExpansion('panel3')
    // }
    // else if(presentSubmitCount() !==4){
    //     handleExpansion('panel4')
    // }
    // else ()

    return (
// In every form group tag instead of just passing the value as column, we have passed column  = "true "

    <div className={classes.root}>
        <div>
      <Accordion>
        <AccordionSummary
          expandIcon=   {<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
        <Typography style = {{fontWeight: 'bold'}} className = {classes.heading}>Getting Started</Typography>
            {/* <Typography style = {{marginLeft: '2rem'}} className={classes.secondaryHeading}>Complete 1-2 weeks  before   hackathon</Typography> 
            <Typography className = {classes.secondaryHeading} style = {{display: 'inline-block', position: 'absolute', right: '80px'}}> 
                {gettingStartedCount()}/5 completed 
            </Typography> */}

            <Typography style = {{marginLeft: '2rem'}} className={classes.secondaryHeading}>Complete before Hackathon 19:00 AEST (Friday)<span className="mobile_view_show">({gettingStartedCount()}/5)</span></Typography> 
            <Typography className ="mobile_view_hide" style = {{position: 'absolute', right: '80px'}}> 
                {gettingStartedCount()}/5 completed 
            </Typography>
        </AccordionSummary>
        <AccordionDetails>
        

          <FormGroup column = "true">
            <FormControlLabel
                control={
                    <Checkbox
                        value = "signUpLogin" 
                        checked = {true}
                        // checked={state.signUpLogin} 
                        // onChange={handleGettingStarted}
                        name="signUpLogin" 
                        disabled = {true}
                    />
                }
                label="Login to Hackerspace"
            />
            <br></br>
            <FormControlLabel
                control={
                    <Checkbox 
                        value = "onboardingVideo"
                        checked={state.onboardingVideo} 
                        onChange={handleGettingStarted} 
                        name="onboardingVideo" 
                        disabled = {state.onboardingVideo}
                    />
                }
                label={<>Get started with the <a rel="noopener noreferrer" href = "//www.youtube.com/watch?v=PUFI6Wd4PVA" target = "_blank">onboarding video</a></>}
            />
            <br/>
            {/* <FormControlLabel
                control={
                    <Checkbox 
                        value = "learnChallenges"
                        checked={state.learnChallenges} 
                        onChange={handleGettingStarted} 
                        name="learnChallenges" 
                        disabled = {state.learnChallenges}
                    />
                }
                label="Learn about the challenges"
            /> */}
            <FormControlLabel
                control={
                    <Checkbox 
                        value = "masterSlackSpace"
                        checked={state.masterSlackSpace} 
                        onChange={handleGettingStarted} 
                        name="masterSlackSpace" 
                        disabled = {state.masterSlackSpace}
                    />
                }
                label = {<>Become a master at using <a rel="noopener noreferrer" href = "//slack.com/intl/en-in/resources/using-slack/how-to-use-slack" target = "_blank">Slack Space</a></>
            }
            />
            <br/>
            <FormControlLabel
                control={
                    <Checkbox 
                        value = "registerSchedule"
                        checked={state.registerSchedule} 
                        onChange={handleGettingStarted} 
                        name="registerSchedule" 
                        disabled = {state.registerSchedule}
                    />
                }
                label={<>Check the day schedule and <a rel="noopener noreferrer" target = "_blank" href = "//calendar.google.com/calendar/u/2/r?cid=cGFydG5lcnNoaXBzQGhhY2ttYWtlcnMuY29t">sync your calendar</a></>}
            />
            <br/>
            <FormControlLabel
                control={
                    <Checkbox 
                        value = "sponsorInfo"
                        checked={state.sponsorInfo} 
                        onChange={handleGettingStarted} 
                        name="sponsorInfo" 
                        disabled = {state.sponsorInfo}
                    />
                }
                label={<>Register for a <a rel="noopener noreferrer" href = "//hackmakers.com/digitaldefence-workshop-schedule/" target = "_blank">sponsored workshop</a></>}
            />
            </FormGroup>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
        <Typography style = {{fontWeight: 'bold'}} className = {classes.heading}>Form Your Team</Typography>
        {/* <Typography style = {{marginLeft: '2rem'}} className={classes.secondaryHeading}>Complete before 12:00; Day  1 of hackathon</Typography>  
        <Typography className = {classes.secondaryHeading} style = {{display: 'inline-block', position: 'absolute', right: '80px'}}>
            {formYourTeamCount()}/4 completed
        </Typography> */}

            <Typography style = {{marginLeft: '2rem'}} className={classes.secondaryHeading}>Complete before 12:00 AEST, Day 1 (Saturday)<span className="mobile_view_show">({formYourTeamCount()}/5)</span></Typography> 
            <Typography className ="mobile_view_hide" style = {{position: 'absolute', right: '80px'}}> 
                {formYourTeamCount()}/4 completed 
            </Typography>


        </AccordionSummary>
        <AccordionDetails>

            <FormGroup column = "true">
            <FormControlLabel
                control={
                    <Checkbox
                        value = "completeProfile" 
                        checked={state.completeProfile} 
                        onChange={handleFormYourTeam}
                        name="completeProfile" 
                        disabled = {state.completeProfile}
                    />
                }
                label={<>Complete your <a rel="noopener noreferrer" href = "//hackmakers-35566.web.app/registration/home" target = "_blank">profile details</a></>}
            />
            <br></br>
            <FormControlLabel
                control={
                    <Checkbox 
                        value = "introYourself"
                        checked={state.introYourself} 
                        onChange={handleFormYourTeam} 
                        name="introYourself" 
                        disabled = {state.introYourself}
                    />
                }
                label={<>Meet other hackers in your <a rel="noopener noreferrer" href = "//digitaldefencehack.slack.com/" target = "_blank">regional group</a></>
            }
            />
            <br/>
            <FormControlLabel
                control={
                    <Checkbox 
                        value = "regionSpeedTeam"
                        checked={state.regionSpeedTeam} 
                        onChange={handleFormYourTeam} 
                        name="regionSpeedTeam" 
                        disabled = {state.regionSpeedTeam}
                    />
                }
                label = {<>Register for a <a rel="noopener noreferrer" href = "//calendar.google.com/calendar/u/2/r?cid=cGFydG5lcnNoaXBzQGhhY2ttYWtlcnMuY29t" target = "_blank">speed teaming session</a></>}
            />
            <br/>
            <FormControlLabel
                control={
                    <Checkbox 
                        value = "introOnSlack"
                        checked={state.introOnSlack} 
                        onChange={handleFormYourTeam} 
                        name="introOnSlack" 
                        disabled = {state.introOnSlack}
                    />
                }
                label={<>Introduce yourself on the <a rel="noopener noreferrer" target = "_blank" href = "//digitaldefencehack.slack.com/archives/C01E5A17DN0">#introductions channel in the slack Space</a></>
            }
            />
            <br/>
            </FormGroup>
        </AccordionDetails>
      </Accordion>


      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
            <Typography style = {{fontWeight: 'bold'}} className = {classes.heading}>Start Hacking</Typography>
            {/* <Typography style={{marginLeft: '2rem'}} className = {classes.secondaryHeading}>Complete before 14:00; Day 2 of hackathon</Typography>
            <Typography className = {classes.secondaryHeading} style = {{display: 'inline-block', position: 'absolute', right: '80px'}}>
              {startHackingCount()}/5 completed
            </Typography> */}

            <Typography style = {{marginLeft: '2rem'}} className={classes.secondaryHeading}>Complete before 14:00 AEST, Day 2 (Sunday)<span className="mobile_view_show">({startHackingCount()}/5)</span></Typography> 
            <Typography className ="mobile_view_hide" style = {{position: 'absolute', right: '80px'}}> 
                {startHackingCount()}/5 completed 
            </Typography>


        </AccordionSummary>
        <AccordionDetails>


            <FormGroup column = "true">
            <FormControlLabel
                control={
                    <Checkbox
                        value = "useCredits" 
                        checked={state.useCredits} 
                        onChange={handleStartHacking}
                        name="useCredits" 
                        disabled = {state.useCredits}
                    />
                }
                label={<>Use credits from a sponsor (<a rel="noopener noreferrer" href = "//digitaldefencehack.slack.com/archives/C01EL307RF0" target = "_blank">Oracle</a> or <a href = "//digitaldefencehack.slack.com/?redir=%2Farchives%2FC01FNUB3CQ0"  rel="noopener noreferrer" target = "_blank">IBM</a>) or choose your own hosting platform</>}
            />
            <br></br>
            <FormControlLabel
                control={
                    <Checkbox 
                        value = "chooseChallenge"
                        checked={state.chooseChallenge} 
                        onChange={handleStartHacking} 
                        name="chooseChallenge" 
                        disabled = {state.chooseChallenge}
                    />
                }
                label="Select a challenge to compete in"
            />
            <br/>
            <FormControlLabel
                control={
                    <Checkbox 
                        value = "findMentor"
                        checked={state.findMentor} 
                        onChange={handleStartHacking} 
                        name="findMentor" 
                        disabled = {state.findMentor}
                    />
                }
                label="Find a mentor in your regional group, or find one in the #ask_a_mentor channel"
            />
            <br/>
            <FormControlLabel
                control={
                    <Checkbox 
                        value = "projectPlanner"
                        checked={state.projectPlanner} 
                        onChange={handleStartHacking} 
                        name="projectPlanner" 
                        disabled = {state.projectPlanner}
                    />
                }
                label="Use a project planner and assumption mapper to organise your team, project and designs "
            />
            <br/>
            <FormControlLabel
                control={
                    <Checkbox 
                        value = "selectDatasets"
                        checked={state.selectDatasets} 
                        onChange={handleStartHacking} 
                        name="selectDatasets" 
                        disabled = {state.selectDatasets}
                    />
                }
                label="Select your datasets, libraries and stacks for hacking"
            />
            <br/>
            </FormGroup>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
            <Typography style = {{fontWeight: 'bold'}} className = {classes.heading}>Present, Submit and Score your Certificate</Typography>
            {/* <Typography style = {{marginLeft: '2rem'}} className = {classes.secondaryHeading}>Complete before 20:00; Day 2 of hackathon</Typography>
            <Typography className = {classes.secondaryHeading} style = {{display: 'inline-block', position: 'absolute', right: '80px'}}>
             {presentSubmitCount()}/4 completed
            </Typography> */}

            <Typography style = {{marginLeft: '2rem'}} className={classes.secondaryHeading}> Complete before 20:00, Day 2 (Sunday)<span className="mobile_view_show">({presentSubmitCount()}/5)</span></Typography> 
            <Typography className ="mobile_view_hide" style = {{position: 'absolute', right: '80px'}}> 
                {presentSubmitCount()}/4 completed 
            </Typography>



        </AccordionSummary>
        <AccordionDetails>

            <FormGroup column = "true">
            <FormControlLabel
                control={
                    <Checkbox
                        value = "startToStoryBoard" 
                        checked={state.startToStoryBoard} 
                        onChange={handlePresentSubmit}
                        name="startToStoryBoard" 
                        disabled = {state.startToStoryBoard}
                    />
                }
                label="Start to storyboard your presentation pitch"
            />
            <br></br>
            <FormControlLabel
                control={
                    <Checkbox 
                        value = "videoSW"
                        checked={state.videoSW} 
                        onChange={handlePresentSubmit} 
                        name="videoSW" 
                        disabled = { state.videoSW }
                    />
                }
                label="Choose a video making software to record and edit your video"
            />
            <br/>
            <FormControlLabel
                control={
                    <Checkbox 
                        value = "teamRepresent"
                        checked={state.teamRepresent} 
                        onChange={handlePresentSubmit} 
                        name="teamRepresent" 
                        disabled = {state.teamRepresent}
                    />
                }
                label="Select one team representative for your group to submit their submission"
            />
            <br/>
            <FormControlLabel
                control={
                    <Checkbox 
                        value = "completeSurvey"
                        checked={state.completeSurvey} 
                        onChange={handlePresentSubmit} 
                        name="completeSurvey" 
                        disabled = {state.completeSurvey}
                    />
                }
                label="Complete the post-hack survey to score your certificate, and win extra prizes."
            />
            <br/>
            </FormGroup>
        </AccordionDetails>
      </Accordion>
      </div>
    </div>
  );
}
// export default AccordionComponent

const condition = authUser => !!authUser;

const AccordionComponent = compose(
  withRouter,
  withFirebase,
)(AccordionComponentBase);

export default withAuthorization(condition)(AccordionComponent);